import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "field"]
  static values = { url: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const params = new URLSearchParams()
    this.fieldTargets.forEach(field => {
      if (field.value) {
        params.append(`filters[${field.dataset.filterKey}]`, field.value)
      }
    })

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    fetch(`${this.urlValue}?${params}`, {
      headers: { "X-CSRF-Token": csrfToken }
    })
      .then(r => r.text())
      .then(count => {
        this.countTarget.textContent = count
      })
  }
}
